import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import _ from "lodash";
import { invalid} from "@codeArt/utils/common";

const Repeater = ({rows, gap, renderItem, layout}) => {
  return (
    <div className="d-flex flex-column">
      <Table>
        <TableBody>
          <tr>
            <td>
              <Cells
                rows={rows}
                gap={gap}
                renderItem={renderItem}
                layout={layout}
              />
            </td>
          </tr>
        </TableBody>
      </Table>
    </div>
  );
};

const Cells = ({rows, gap, renderItem, layout}) => {
  const renderCell = (item, index) => {
    let _gap = !invalid(gap) ? gap : 2;
    return (
      <div key={index} className={`col-12 ${layout} p-${_gap}`}>
        {renderItem(item, index)}
      </div>
    );
  };

  return (
    <div className={`row no-gutters c-mx--${gap || 2}`}>
      {rows.map((row, rowIndex) => {
        return renderCell(row, rowIndex);
      })}
    </div>
  );
};

export {Repeater};
